import type React from 'react';

export const ToolbarSeparator: React.FC = () => {
    return (
        <div className='w-[1px] h-6 bg-gray-300' />
    );
};
